import React, { useState } from "react";
import FiltersModalPropio from "./FiltersModalPropio";
import companyData from "../../Data/CompanyData";
import categories from "../../Data/Categories";
import { ciudadesPeru } from "../../Data/PeruDistricts";
import filtrosTender from "../../Data/FiltrosTender";
import { Button } from "../../components/ui/button";
import {
  Sheet,
  SheetTrigger,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "../../components/ui/sheet";

const FiltroLicitacionesPropias = ({
  filters,
  setFilters,
  onClearFilters,
  setPage,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("");
  const [showFiltersMenu, setShowFiltersMenu] = useState(false);

  // Opciones de filtros provenientes de los datos importados
  const optionsData = {
    categoria: [
      ...categories.filter((cat) => cat.label !== "Otro Servicio"),
      ...companyData.sectores,
    ],
    ciudad: ciudadesPeru.map((city) => ({ label: city, icon: "" })),
    condiciones_pago: filtrosTender.condicionesPago,
    duracion_contrato: filtrosTender.duracionContrato,
    fecha: filtrosTender.fechas,
  };

  // Títulos amigables para mostrar en el modal
  const friendlyTitles = {
    categoria: "Categorías",
    ciudad: "Ciudades",
    condiciones_pago: "Condiciones de pago",
    duracion_contrato: "Duración del contrato",
    fecha: "Fechas",
  };

  const filterButtons = [
    { key: "categoria", label: "Categorías" },
    { key: "ciudad", label: "Ciudades" },
    { key: "condiciones_pago", label: "Condiciones de pago" },
    { key: "duracion_contrato", label: "Duración del contrato" },
    { key: "fecha", label: "Fechas" },
  ];

  const isFilterActive = (key) => (filters[key]?.length || 0) > 0;

  // Abre el modal con el filtro activo
  const handleFilterClick = (filterType) => {
    setActiveFilter(filterType);
    setIsModalOpen(true);
  };

  // Aplica el filtro seleccionado desde el modal y reinicia la página
  const handleModalApply = (filterType, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterType]: value,
    }));
    setIsModalOpen(false);
    setPage(1); // Reinicia la página
  };

  // Limpia todos los filtros
  const handleClearFilters = () => {
    setFilters({
      categoria: [],
      ciudad: [],
      condiciones_pago: [],
      duracion_contrato: [],
      fecha: [],
    });
    setPage(1); // Reinicia a la primera página
    if (onClearFilters) {
      onClearFilters();
    }
  };

  return (
    <div className="mb-6 flex flex-wrap items-center gap-2">
      <div className="hidden flex-wrap items-center gap-2 md:flex">
        {filterButtons.map((btn) => (
          <Button
            key={btn.key}
            variant={isFilterActive(btn.key) ? "default" : "outline"}
            onClick={() => handleFilterClick(btn.key)}
          >
            {btn.label}
          </Button>
        ))}
        <Button variant="ghost" onClick={handleClearFilters}>
          Limpiar Filtros
        </Button>
      </div>

      <Sheet open={showFiltersMenu} onOpenChange={setShowFiltersMenu}>
        <SheetTrigger asChild>
          <Button variant="outline" className="md:hidden">
            Mostrar filtros
          </Button>
        </SheetTrigger>
        <SheetContent side="left">
          <SheetHeader>
            <SheetTitle>Todos los filtros</SheetTitle>
          </SheetHeader>
          <div className="flex flex-col gap-2">
            {filterButtons.map((btn) => (
              <Button
                key={btn.key}
                variant={isFilterActive(btn.key) ? "default" : "outline"}
                className="w-full justify-start"
                onClick={() => handleFilterClick(btn.key)}
              >
                {btn.label}
              </Button>
            ))}
          </div>
          <div className="mt-4 flex flex-col gap-2 border-t border-border pt-4">
            <Button onClick={() => setShowFiltersMenu(false)}>Aplicar Filtros</Button>
            <Button variant="outline" onClick={handleClearFilters}>
              Limpiar Filtros
            </Button>
          </div>
        </SheetContent>
      </Sheet>

      {isModalOpen && (
        <FiltersModalPropio
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          options={optionsData[activeFilter] || []}
          selectedOptions={filters[activeFilter] || []}
          setSelectedOptions={(newOptions) =>
            handleModalApply(activeFilter, newOptions)
          }
          title={`Seleccionar ${friendlyTitles[activeFilter] || activeFilter}`}
        />
      )}
    </div>
  );
};

export default FiltroLicitacionesPropias;
